<template lang="pug">
  .kr-embedded-method-display-wrapper(v-show="show" :class="dynamicClasses")
    .kr-embedded-method-display(ref="methodDisplay")
      .kr-embedded-method-header(v-if="method" @click="setDefaultActiveMethod()" ref="header")
        BrandIcon(:method="method")
        .kr-embedded-method-label {{ methodLabel }}

      // margin of 2 pixels for the border top + border bottom
      EmbeddedMethod(
        :method="method"
        :extraMargin="extraMargin"
        @height="updateHeight"
      )
</template>

<script>
import EmbeddedMethod from '@/host/components/smartform/embeddedMethod/EmbeddedMethod'
import BrandIcon from '@/host/components/controls/BrandIcon'
import { mapActions, mapGetters } from 'vuex'
import { parseCssTime } from '@/common/util/style'

export default {
  name: 'EmbeddedMethodDisplay',
  components: {
    EmbeddedMethod,
    BrandIcon
  },
  data() {
    return {
      method: null,
      show: false,
      extraMargin: 0
    }
  },
  computed: {
    ...mapGetters([
      'activeEmbeddedMethod',
      'getCustomPaymentMethodLabel',
      'getPaymentMethodLabel',
      'hasExactSmartButton'
    ]),
    methodLabel() {
      return (
        this.getCustomPaymentMethodLabel(this.method) ||
        this.getPaymentMethodLabel(this.method)
      )
    },
    dynamicClasses() {
      return {
        'kr-illicado': ['ILLICADO', 'CARDS:ILLICADO'].includes(this.method)
      }
    }
  },
  watch: {
    async activeEmbeddedMethod(newVal) {
      if (newVal) {
        // If the method is on a smartbutton never open this display
        if (this.hasExactSmartButton(newVal.toString())) return

        this.show = true
        this.method = newVal.toString()
      }
    }
  },
  mounted() {
    this.extraMargin =
      window
        .getComputedStyle(this.$refs.methodDisplay)
        .getPropertyValue('border-width')
        .replace('px', '') * 2
  },
  methods: {
    ...mapActions(['setDefaultActiveMethod']),
    updateHeight(height) {
      if (height === 0) {
        // trigger the transition start
        this.$el.style.height = '0px'

        // set timeout to set the display none (and don't show the grid gap) after the transition
        setTimeout(() => {
          this.show = false
        }, this.getTransitionDuration())
      } else this.$el.style.height = this.getHeaderHeight() + height + 'px'
    },
    getTransitionDuration() {
      const cssDuration = window
        .getComputedStyle(this.$el)
        .getPropertyValue('transition-duration')

      return parseCssTime(cssDuration)
    },
    getHeaderHeight() {
      return this.$refs.header.getBoundingClientRect().height
    }
  }
}
</script>
